module.exports = __webpack_public_path__ + "static/media/rs.c89987db.svg";